import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared/shared.module";
import { ApplicationBankingInformationComponent } from "./application/application-banking-information/application-banking-information.component";
import { ApplicationBusinessInfoComponent } from "./application/application-business-info/application-business-info.component";
import { ApplicationHelpComponent } from "./application/application-help/application-help.component";
import { ApplicationLegalInformationComponent } from "./application/application-legal-information/application-legal-information.component";
import { ApplicationMerchantContactComponent } from "./application/application-merchant-contact/application-merchant-contact.component";
import { MerchantContactRecordComponent } from "./application/application-merchant-contact/merchant-contact-record/merchant-contact-record.component";
import { ApplicationPaymentServiceRatesComponent } from "./application/application-payment-service-rates/application-payment-service-rates.component";
import { ApplicationRestaurantInformationComponent } from "./application/application-restaurant-information/application-restaurant-information.component";
import { ApplicationSubmittedSuccessfullyComponent } from "./application/application-submitted-successfully/application-submitted-successfully.component";
import { ApplicationTermsAndConditionsComponent } from "./application/application-terms-and-conditions/application-terms-and-conditions.component";
import { ApplicationComponent } from "./application/application.component";
import { FocusPayRoutingModule } from "./focuspay-routing.module";
import { TermsAndConditionsComponent } from "./terms-and-conditions/terms-and-conditions.component";
import { PreappComponent } from './preapp/preapp.component';

@NgModule({
	declarations: [
		ApplicationComponent,
		TermsAndConditionsComponent,
		ApplicationHelpComponent,
		ApplicationMerchantContactComponent,
		ApplicationPaymentServiceRatesComponent,
		ApplicationTermsAndConditionsComponent,
		ApplicationBankingInformationComponent,
		ApplicationBusinessInfoComponent,
		ApplicationLegalInformationComponent,
		ApplicationRestaurantInformationComponent,
		MerchantContactRecordComponent,
		ApplicationSubmittedSuccessfullyComponent,
  PreappComponent,
	],
	imports: [SharedModule, FocusPayRoutingModule],
	exports: [ApplicationComponent],
})
export class FocuspayModule {}
